angular.module('llax')
    .service('DefaultWidgetService', function($q, $timeout, $rootScope, $modal, $log) {
        this.getActions = function(attribute, value) {
            // Example logic: only enable delete if there is a value
            var actions = ['addEntry', 'copyEntry', 'deleteEntry'];
            return actions;
        };

        this.executeAction = function(action, attribute, value, index) {
            var deferred = $q.defer();
            switch(action) {
                case 'addEntry':
                    $timeout(function (){
                        deferred.resolve({});
                    }, 100);
                    break;
                case 'deleteEntry':
                    deferred.resolve({});
                    break;

                case 'copyEntry':
                    $timeout(function () {
                        deferred.resolve(null);
                    }, 100);
                    break;

                default:
                    deferred.reject('Unknown action: ' + action);
            }

            return deferred.promise;
        };
    });
